export default "__VITE_ASSET__Nqtr9B3l__"